import { tv } from 'tailwind-variants';

export const radioRecipe = tv({
  slots: {
    container: 'group flex cursor-pointer items-center',
    inputWrapper: 'relative flex h-4 w-4 items-center',
    input: 'sr-only',
    label: `
      relative h-4 w-4 cursor-pointer rounded-full border
      group-active:border-2 group-active:border-brand-fill-brand
      !m-0
    `,
    dot: `
      absolute inset-0 m-auto flex h-2 w-2 items-center justify-center
      rounded-full bg-white transition-transform duration-100 ease-in-out
    `,
    textLabel: `
      ml-2 block cursor-pointer text-sm transition-colors duration-200
    `,
  },
  variants: {
    isSelected: {
      true: {
        label: 'border-brand-fill-brand bg-brand-fill-brand',
        dot: 'scale-100',
      },
      false: {
        label: `
          border-brand-gray-12 bg-transparent
          group-hover:border-brand-gray-13 group-hover:bg-brand-gray-3
          group-hover:dark:bg-brand-gray-16
        `,
        dot: 'scale-0',
      },
    },
    isDisabled: {
      true: {
        container: 'cursor-not-allowed',
        textLabel: 'text-content-disabled cursor-not-allowed',
      },
      false: {
        textLabel: 'text-content cursor-pointer',
      },
    },
  },
  defaultVariants: {
    isSelected: false,
    isDisabled: false,
  },
});

/**
 * @typedef {import('tailwind-variants').VariantProps<typeof radioRecipe>} RadioRecipeVariants
 */
